import React from 'react';
import { Drawer, Typography, Input } from 'antd';
import { useIntl } from 'react-intl';
import { MailOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { getUserMeta } from 'shared/config/store/reducers/userSlice';
import styles from './ChangeEmailDrawer.module.scss';

const { Text } = Typography;

type Props = {
  open: boolean;
  onClose: () => void;
};

const ChangeEmailDrawer = ({ open, onClose }: Props) => {
  const { formatMessage: t } = useIntl();
  const user = useSelector(getUserMeta);

  return (
    <Drawer
      title={t({ id: 'changeEmail.drawer.title' })}
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
      closeIcon={true}
      bodyStyle={{ padding: 24 }}
    >
      <div className={styles.centered}>
        <div className={styles.iconWrapper}>
          <MailOutlined style={{ fontSize: 32 }} />
        </div>

        <Text type="secondary" className={styles.message}>
          {t({ id: 'changeEmail.drawer.unavailableMessage' })}
        </Text>
        <Text className={styles.label}>
          {t({ id: 'changeEmail.drawer.yourEmail' })}
        </Text>
        <div className={styles.emailBlock}>
          <Input
            value={user.email}
            disabled
            bordered={false}
            className={styles.emailInput}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default ChangeEmailDrawer;
